import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFormatBoldStyle0 = cosmosIconCss;

const CosmosIconFormatBold$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFormatBold extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7421e852b3cc9be3113f913efb9555653797d3f9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'eba1a24927c9d0c65a8462d9610328e40aa8521f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '96b2eb8f1bb4c649ddd3227255615ca966145344', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 14.13c0 2.39-1.69 3.87-4.37 3.87H6.5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h4.65c2.66 0 4.26 1.37 4.26 3.66a3.51 3.51 0 0 1-1.33 3A3.51 3.51 0 0 1 16 14.13ZM9 6.56v3h1.8c1.11 0 1.75-.45 1.75-1.47s-.58-1.48-1.71-1.48L9 6.56Zm2.12 8.88c1.27 0 2-.56 2-1.73s-.75-1.65-2-1.65H9v3.38h2.12Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFormatBoldStyle0; }
}, [1, "cosmos-icon-format-bold", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-format-bold"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-format-bold":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFormatBold$1);
            }
            break;
    } });
}

const CosmosIconFormatBold = CosmosIconFormatBold$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFormatBold, defineCustomElement };
